import React from "react";

import { LuCalculator, LuWrench } from "react-icons/lu";
import SNCalculator from "./SNCalculator";
import { MODULE_TOOLS, MODULE_NOE_CALCULATOR } from "variables/constants";

const toolsRoutes = [	
	{
	    name: "Tools",
	    layout: "/console",
	    path: "#",
	    icon: <LuWrench className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: 0,
	    children: [
			{
				name: "SN Calculator",
				layout: "/console",
				path: "sn-calculator",
				icon: <LuCalculator className="icon-item" />,
				component: <SNCalculator />,
				isMainMenu:true,
				level:3,
				moduleId: 0,
			},
		],
  	},
]

export default toolsRoutes;